import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import Dialog from '../biz/dialog';
import Cookie from '../../common/cookie';
import LoginStatus from '../../common/loginStatus';
import ATM from '../../util/atm';
import postByIframe from './postByIframe';
import postByCors from './postByCors';
import platform from '../../common/platform';
import { isObject } from '../../common/base'; // 全局HTTPCODE提示

var GLOBAL_STATUS_ERROR = {
  // 200:""//200表示正常返回，不用提示
  503: function _() {
    Cookie.set('_AMSSafeguard', new Date().getTime() + 30 * 1000, 30, window.location.host, '/', false);
    alert('很抱歉当前访问人数过多,请稍后再试');
  },
  401: '系统繁忙，请稍后再试',
  // 401防刷保护
  other: '系统繁忙' // 其它提示

};

var DD_GLOBAL_SATAUS_ERROR = function DD_GLOBAL_SATAUS_ERROR(err) {
  if ('string' === typeof err) {
    alert(err);
  } else if ('function' === typeof err) {
    err();
  }
}; // 存储耗时相关


var TIME_COST_DATA = {
  /* '145345':{
        start:12234,
        end:12000,
        cost:234
    }*/
};
var defaultFlowData = {
  sUrl: '',
  iFlowId: '',
  // 必须传,根据这个id会生成一个全局函数,数据提交成功后回
  submitPre: null,
  submitEnd: null,
  // 把返回值回传给回调函数
  sData: {},
  sNeedSubmitPopDiv: true
};

var Flow = /*#__PURE__*/function () {
  function Flow(opt) {
    _classCallCheck(this, Flow);

    this.flowJsonData = _objectSpread(_objectSpread({}, defaultFlowData), opt);
  }

  _createClass(Flow, [{
    key: "request",
    value: function request() {
      var flow = this;
      return new Promise(function (resolve, reject) {
        // 同步qc登录态到game.qq.com
        LoginStatus.syncToAME(function () {
          flow.timeCostStart(flow.flowJsonData.iFlowId);

          if (!platform.isMobile()) {
            postByIframe(flow).then(function (res) {
              resolve(res);
            })["catch"](function (err) {
              flow.onError(err);
            });
          } else {
            postByCors(flow).then(function (res) {
              resolve(res);
            })["catch"](function (err) {
              flow.onError(err);
              reject(err);
            });
          }
        });
      });
    }
  }, {
    key: "onError",
    value: function onError(err) {
      var _err$objData = err.objData,
          objData = _err$objData === void 0 ? {} : _err$objData,
          _err$url = err.url,
          url = _err$url === void 0 ? '' : _err$url;
      var _this$flowJsonData = this.flowJsonData,
          iActivityId = _this$flowJsonData.iActivityId,
          iFlowId = _this$flowJsonData.iFlowId,
          sData = _this$flowJsonData.sData;
      ATM.reportATM({
        toappid: 1,
        tomoduletype: url.replace(/\?.+/, ''),
        tointer: 1,
        toreturncode: 1,
        result: 0 - objData.status,
        serialnum: '',
        actid: iActivityId,
        businesstype: sData.sServiceType,
        errormsg: "\u670D\u52A1\u5668".concat(objData.status),
        timecost: this.getTimeCost(iFlowId)
      });

      if (GLOBAL_STATUS_ERROR[objData.status]) {
        // eslint-disable-next-line new-cap
        DD_GLOBAL_SATAUS_ERROR(GLOBAL_STATUS_ERROR[objData.status]);
      } else {
        // eslint-disable-next-line new-cap
        DD_GLOBAL_SATAUS_ERROR(GLOBAL_STATUS_ERROR.other);
      }
    }
  }, {
    key: "timeCostStart",
    value: function timeCostStart(iFlowId) {
      if (isObject(TIME_COST_DATA[iFlowId])) {
        TIME_COST_DATA[iFlowId].start = new Date().getTime();
      } else {
        TIME_COST_DATA[iFlowId] = {
          start: new Date().getTime()
        };
      }
    }
  }, {
    key: "timeCostEnd",
    value: function timeCostEnd(iFlowId) {
      if (isObject(TIME_COST_DATA[iFlowId])) {
        TIME_COST_DATA[iFlowId].end = new Date().getTime();
      } else {
        TIME_COST_DATA[iFlowId] = {
          end: new Date().getTime()
        };
      }
    }
  }, {
    key: "getTimeCost",
    value: function getTimeCost(iFlowId) {
      var timeObj = TIME_COST_DATA[iFlowId] || {};
      var start = timeObj.start;
      var end = timeObj.end;

      if (start && end) {
        return end - start;
      }

      return 0;
    }
  }]);

  return Flow;
}();

export default Flow;